export const index = '/';
export const meetings = '/meetings';
export const files = '/files';
export const members = '/members';
export const reports = '/reports';
export const login = '/login';
export const mobile = '/mobile';
export const document = '/document';
